var COS = require('cos-js-sdk-v5')
import { Message } from 'element-ui'

var url = window.location.href
var start = url.indexOf('#/') + 2
var end = url.indexOf('/index')
var result = url.substring(start, end)
console.log(result)

// 随机生成的数字
function generateUniqueString() {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, '')
  const timestamp = Date.now().toString()
  let randomString = ''
  for (let i = 0; i < 5; i++) {
    randomString += letters.charAt(Math.floor(Math.random() * letters.length))
  }
  return randomString + currentDate + timestamp
}

/**
 * 上传图片/视频到腾讯云 COS
 * @param {File} files
 * @param {Function} progressEvent
 * @param {string} name
 * @param {Object} config
 * @returns {Promise}
 */
export function uploadFilesimg(files, progressEvent, name, config) {
  // 取配置
  const SecretId = config.secret_id
  const SecretKey = config.secret_key
  const bucket = config.bucket
  const region = config.region
  const cos = new COS({
    SecretId,
    SecretKey
  })

  const uniqueString = generateUniqueString()

  let extension = ''
  if (files.name) {
    extension = files.name.substring(files.name.lastIndexOf('.') + 1)
  }

  // 文件路径
  const fileExtension = files.name.split('.').pop().toLowerCase()
  let filePath = ''
  if (['mp4', 'mov'].includes(fileExtension)) {
    filePath = `/dj/video/${name}/newlyinmessage/${name}${uniqueString}.${extension}`
  } else if (['jpeg', 'jpg', 'png', 'gif'].includes(fileExtension)) {
    filePath = `/dj/img/${name}/newlyinmessage/${name}${uniqueString}.${extension}`
  }

  var fileList = [files].map(file => ({
    Bucket: bucket,
    Region: region,
    Key: filePath,
    Body: file
  }))

  return new Promise((resolve, reject) => {
    cos.uploadFiles({
      files: fileList,
      SliceSize: 1024 * 1024 * 5,
      onProgress: function(progressData) {
        const num = progressData.loaded / progressData.total * 100 | 0
        progressEvent(num)
      },
      onFileFinish: function(err, data, options) {
        console.log('err', err)
        err ? Message('上传失败') : Message.success('上传成功')
      }
    }, function(err, data) {
      if (err) {
        reject(err)
      } else {
        console.log('data+++++++++++++++++++++:', data.files[0].options.Key)
        resolve(data)
      }
    })
  })
}
// 提供给广告页面使用的图片上传函数
export function uploadFilesimgss(files, progressEvent, name, config) {
  // 取配置
  const SecretId = config.secret_id
  const SecretKey = config.secret_key
  const bucket = config.bucket
  const region = config.region
  const cos = new COS({
    SecretId,
    SecretKey
  })

  const uniqueString = generateUniqueString()

  let extension = ''
  if (files.name) {
    extension = files.name.substring(files.name.lastIndexOf('.') + 1)
  }
  const currentDate = (() => {
    const d = new Date()
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${y}${m}${day}`
  })()

  // 文件路径
  const fileExtension = files.name.split('.').pop().toLowerCase()
  let filePath = ''
  if (['mp4', 'mov'].includes(fileExtension)) {
    filePath = `/adPage/${currentDate}/${uniqueString}.${extension}`
  } else if (['jpeg', 'jpg', 'png', 'gif'].includes(fileExtension)) {
    filePath = `/adPage/${currentDate}/${uniqueString}.${extension}`
  }

  var fileList = [files].map(file => ({
    Bucket: bucket,
    Region: region,
    Key: filePath,
    Body: file
  }))

  return new Promise((resolve, reject) => {
    cos.uploadFiles({
      files: fileList,
      SliceSize: 1024 * 1024 * 5,
      onProgress: function(progressData) {
        const num = progressData.loaded / progressData.total * 100 | 0
        progressEvent(num)
      },
      onFileFinish: function(err, data, options) {
        console.log('err', err)
        err ? Message('上传失败') : Message.success('上传成功')
      }
    }, function(err, data) {
      if (err) {
        console.log(err)
        reject(err)
      } else {
        console.log('data+++++++++++++++++++++:', data.files[0].options.Key)
        resolve(data)
      }
    })
  })
}

/**
 * 上传 HTML 到腾讯云 COS （提供给广告页面使用，由后端传递uploadUrl）
 * @param {string} htmlContent - 完整 HTML 字符串
 * @param {string} uploadUrl   - 上传路径（如 /dj/html/xxxx.html），来自后端
 * @param {Function} [progressEvent] - 进度回调 (percent)
 * @param {Object} config      - 腾讯云 COS 配置对象
 * @returns {Promise<{ fileKey: string, fileUrl: string }>}
 */
export function uploadHtmlToCos(htmlContent, uploadUrl, progressEvent, config, htmlNo) {
  const { bucket, region, domain, secret_id, secret_key } = config
  const cos = new COS({
    SecretId: secret_id,
    SecretKey: secret_key
  })

  // 生成 Blob 和 File
  const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' })
  // 随便给文件名，反正COS只看Key
  const file = new File([blob], `${htmlNo}.html`, { type: 'text/html;charset=utf-8' })

  const fileList = [{
    Bucket: bucket,
    Region: region,
    Key: uploadUrl, // 后端给的 key
    Body: file
  }]

  return new Promise((resolve, reject) => {
    cos.uploadFiles({
      files: fileList,
      SliceSize: 5 * 1024 * 1024,
      onProgress(progressData) {
        const percent = Math.floor(progressData.loaded / progressData.total * 100)
        progressEvent && progressEvent(percent)
      },
      onFileFinish(err) {
        if (err) {
          Message.error('HTML 上传失败')
        } else {
          Message.success('HTML 上传成功')
        }
      }
    }, (err) => {
      if (err) {
        reject(err)
      } else {
        // 域名与 key 拼接，去重斜杠
        let url = domain || ''
        let key = uploadUrl || ''
        url = url.replace(/\/+$/, '')
        key = key.replace(/^\/+/, '')
        const fileUrl = url + '/' + key
        resolve({
          fileKey: uploadUrl,
          fileUrl
        })
      }
    })
  })
}

/**
* 上传文件到腾讯云 COS（通用方法）
* @param {File} file 文件对象
* @param {Function} progressEvent 上传进度回调 (百分比)
* @param {string} name 文件夹名（用于组织和检索）
* @param {Object} config 腾讯云配置（包含 secret_id、secret_key、bucket、region）
* @returns {Promise<string>} 返回最终的 Key
*/
export function uploadFileToCos(file, progressEvent, name, config) {
  const { secret_id, secret_key, bucket, region } = config

  const cos = new COS({
    SecretId: secret_id,
    SecretKey: secret_key
  })

  // 当前日期
  const date = new Date()
  const yyyy = date.getFullYear()
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const dd = String(date.getDate()).padStart(2, '0')
  const today = `${yyyy}-${mm}-${dd}`

  // 文件扩展名
  const extension = file.name ? file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase() : 'mp4'

  // 文件名：随机6位 + 下划线 + 01
  const randomName = `${generateRandomString(6)}_01`

  // 文件路径
  const filePath = `/${name}/${today}/${randomName}.${extension}`

  const fileList = [{
    Bucket: bucket,
    Region: region,
    Key: filePath,
    Body: file
  }]

  return new Promise((resolve, reject) => {
    cos.uploadFiles({
      files: fileList,
      SliceSize: 1024 * 1024 * 5,
      onProgress(progressData) {
        const percent = Math.floor((progressData.loaded / progressData.total) * 100)
        if (typeof progressEvent === 'function') {
          progressEvent(percent)
        }
      },
      onFileFinish(err) {
        if (err) {
          console.error('单个文件上传失败:', err)
        } else {
          console.log('单个文件上传完成')
        }
      }
    }, (err, data) => {
      if (err) {
        console.error('上传失败', err)
        reject(err)
      } else {
        const uploadedKey = data.files[0].options.Key
        console.log('上传成功，Key:', uploadedKey)
        resolve(uploadedKey) // ✅ 返回 Key
      }
    })
  })
}
function generateRandomString(length = 6) {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}
